/**
 * Sticky Header
 * Replaces jQuery scroll handler with IntersectionObserver.
 * Adds .is-sticky to .main-menu__container when scrolled past threshold.
 */

function init() {
  const header = document.querySelector('.main-menu__container');
  if (!header) return;

  // Create a sentinel element at the top of the page
  const sentinel = document.createElement('div');
  sentinel.className = 'scroll-sentinel';
  sentinel.setAttribute('aria-hidden', 'true');
  // Position it at 40px from top (the original scroll threshold)
  sentinel.style.cssText = 'position:absolute;top:40px;height:1px;width:1px;pointer-events:none;';
  document.body.prepend(sentinel);

  const observer = new IntersectionObserver(
    ([entry]) => {
      header.classList.toggle('is-sticky', !entry.isIntersecting);
    },
    { threshold: 0 }
  );

  observer.observe(sentinel);
}

// Auto-init
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
